// Customer-facing toasts, validation messages, and inline errors. See
// docs/features/2026.10.09-static-string-consolidation/decisions/2026.10.09-001-static-copy-data-objects.md

export const feedbackContent = {
  // Cart mutations
  addedToCartTemplate: '"##BundleName##" was added to your cart!',
  addToCartFailedTemplate:
    'Failed to add "##BundleName##" to your cart. Please try again or contact customer service.',
  removedFromCartTemplate: '"##BundleName##" was removed from your cart!',
  removeFromCartFailedTemplate:
    'Failed to remove "##BundleName##" from your cart. Please try again or contact customer service.',
  // When the bundle has no content name
  unnamedItemAddedToCart: 'The item was added to your cart!',
  unnamedItemAddToCartFailed:
    'Failed to add the item to your cart. Please try again or contact customer service.',
  unnamedItemRemovedFromCart: 'The item was removed from your cart!',
  unnamedItemRemoveFromCartFailed:
    'Failed to remove the item from cart. Please try again or contact customer service.',
  removeBundleFailed:
    'There was an error removing the bundle from your cart. Please try again or contact customer service.',
  selectionSwapFailed:
    'We couldn’t change your selection. Please try again or contact customer service.',
  // Busy-cart 409s, keyed on the server's `reason`
  cartBeingUpdated: 'Your cart is being updated. Please try again in a moment.',
  cartPaymentInProgress:
    'A payment is in progress for this cart. Please wait for it to finish before making changes.',
  // A cart write that timed out, after the cart is refetched
  cartChangeUnconfirmed:
    'That took too long, so we’ve refreshed your cart. Please check it and try again.',

  // Promo codes
  promoCodeAppliedTemplate: 'Promo code ##PromoCode## applied successfully!',
  // Two spaces before "Please" as shipped; logged as a copy defect.
  promoCodeApplyFailedTemplate: 'Failed to apply promo code ##PromoCode##.  Please try again.',

  // Required before continuing
  selectPackageToContinue: 'Please select a package to continue.',
  finishPackageToContinue: 'Please finish building your package before continuing.',
  configureAllPosesToContinue: 'Please configure all poses before continuing.',
  configureAllItemsToContinue: 'Please configure all items before continuing.',
  makeBackgroundSelectionToContinue: 'Please make your background selection before continuing.',
  selectBackgroundImageToContinue: 'Please select a background image before continuing.',
  makeRetouchingSelectionsToContinue: 'Please make your retouching selections before continuing.',
  maxPosesReached:
    'You have reached the maximum number of poses. Please remove a pose before adding a new one.',

  // Save and load failures
  saveDefaultBackgroundFailed:
    'There was an error saving your default background. Please make your selection and continue.',
  saveBackgroundSelectionFailed:
    'There was an error saving your background selection. Please try again or contact customer service.',
  removeRetouchingFailed:
    'There was an error removing the retouching bundle. Please try again or contact customer service.',
  saveRetouchingSelectionsFailed:
    'An error occurred while saving your retouching selections. Please try again. If the issue persists, contact customer support.',
  saveCustomizationsFailed:
    'Failed to save your customizations. Please try again or contact customer service.',
  saveCartConfigurationFailed:
    'Failed to save your cart configuration. Please try again or contact customer service.',
  savePackageFailed: 'Failed to save your package. Please try again or contact customer service.',
  updatePromptValueFailed: 'An error occurred while updating the prompt value.',
  underclassImageLoadFailed:
    'There was an error loading your Underclass image, as it may not be ready yet. Please try again later or contact customer service.',
  underclassImageLocked:
    'You cannot change the image for the Underclass market. If this is a mistake, please contact customer service.',
  termsAcceptanceFailed: 'We couldn’t record your acceptance. Please try again.',
  // Deliberately generic: the cause goes to New Relic, not the customer.
  navigationUnavailable:
    'We could not open that page. Please try again or contact customer service.',

  // Checkout
  requiredFieldsMissing: 'Please fill out all required fields.',
  cartValidationFailed:
    'There was an error validating your cart. Please try again or contact customer service.',
  saveDetailsFailed:
    'There was an error saving your details. Please try again or contact customer service.',
  cartInvalid:
    'There was an error with your cart. Please review your cart items or contact customer service.',
  orderProcessingFailed: 'There was an error processing your order. Please try again.',
  orderServerErrorTemplate:
    '##ServerMessage## Please try again or contact technical support for assistance.',
  paymentFailed: 'There was an error with your payment, please try again.',
  paymentFormLoadFailed:
    'We could not load the payment form. Please refresh the page and try again.',
  paymentFormNotReady: 'The payment form is not ready yet. Please refresh the page and try again.',
  paymentSubmitFailed: 'There was a problem submitting your payment. Please try again.',
  paymentTotalChanged: 'Your total has changed. Please review and tap Pay again.',
  orderCompletedInAnotherTab: 'Your order was completed in another tab.',
  addressFormLoadFailed:
    'We could not load the address form. Please refresh the page and try again.',
  addressFormNotReady: 'The address form is not ready yet. Please refresh the page and try again.',
  shippingTerritoryUnsupported: 'We do not ship to US territories or possessions.',

  // Field validation
  fieldRequired: 'This field is required.',
  retouchingImageRequired: 'Please select an image for retouching.',
  firstNameHasCityStateZip: 'First name should not contain city, state, or zipcode.',
  lastNameHasCityStateZip: 'Last name should not contain city, state, or zipcode.',
  addressLine1HasCityStateZip: 'Address line 1 should not contain city, state, or zipcode.',
  emailRequired: 'Please provide an email address.',
  emailInvalid: 'Please provide a valid email address.',
  phoneRequired: 'Please provide a phone number.',
  phoneInvalid: 'Please provide a valid phone number.',
  termsRequired: 'Please accept the terms & conditions before continuing.',
  relationshipRequired: 'Please provide your relationship to student.'
}
